export const isKernelV2 = (version) => {
    const regex = /0\.2\.\d+/;
    return regex.test(version);
};
//# sourceMappingURL=isKernelV2.js.map